import { render, staticRenderFns } from "./PayPermeate.vue?vue&type=template&id=89d1b2f8"
import script from "./PayPermeate.vue?vue&type=script&lang=js"
export * from "./PayPermeate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports